<template>
    <v-btn depressed :disabled="disabled" :plain="plain" :block="block" :color="color" :text="text"
           :loading="loading" v-bind="$attrs" v-on="$listeners"
           :class="{'white--text':color && !plain && !text}">
        <v-icon v-if="icon" left :style="iconOptions">{{
                icon
            }}
        </v-icon>
        <span class="button">
             <slot></slot>
        </span>
    </v-btn>
</template>

<script>
import ada from '../../scss/ada_colors.scss';

export default {
    name: "Button",
    props: {
        icon: {
            type: String,
            default: null
        },
        iconOptions: {
            type: Object,
            default: () => {
            }
        },
        color: {
            type: String,
            default: null
        },
        plain: {
            type: Boolean,
            default: false
        },
        block: {
            type: Boolean,
            default: false,
        },
        text: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data: () => {
        return {
            ada
        }
    }
}
</script>

<style lang="scss" scoped>
.pink {
    color: $ada_pink;
}

.blue {
    color: $ada_blue;
}

.purple {
    color: $ada_purple;
}

.button {
    transition: all 0.3s ease-in-out;
}

</style>